/** Lecture au ralenti : quelle image afficher à l'instant `elapsedMs` de la lecture. */
interface Timed {
  readonly t: number;
}

export function frameAt(frames: readonly Timed[], elapsedMs: number, speed: number): number {
  if (!(speed > 0)) throw new Error('vitesse invalide');
  if (frames.length === 0) return -1;
  const clipTime = (frames[0]?.t ?? 0) + Math.max(0, elapsedMs) * speed;
  let index = 0;
  for (let i = 0; i < frames.length; i++) if ((frames[i]?.t ?? Infinity) <= clipTime) index = i;
  return index;
}

/** Durée totale de lecture (ms), dernière image comprise. */
export function playbackDuration(frames: readonly Timed[], speed: number): number {
  const first = frames[0]?.t;
  const last = frames.at(-1)?.t;
  if (first === undefined || last === undefined) return 0;
  const step = frames.length > 1 ? (last - first) / (frames.length - 1) : 0;
  return (last - first + step) / speed;
}
